import React from "react";
import { createStyles, Divider, List, ListItem, ListItemText, makeStyles, Theme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { State } from "../../store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  })
);

const AccountInfo: React.FC = () => {
  const classes = useStyles();
  const { firstName, lastName, email, phone } = useSelector((state: State) => state.auth.webUser);
  return (
    <List className={classes.root}>
      <ListItem>
        <ListItemText primary="Imię" secondary={firstName} />
      </ListItem>
      <Divider component="li" />
      <ListItem>
        <ListItemText primary="Nazwisko" secondary={lastName} />
      </ListItem>
      <Divider component="li" />
      <ListItem>
        <ListItemText primary="E-mail" secondary={email} />
      </ListItem>
      <Divider component="li" />
      <ListItem>
        <ListItemText primary="Telefon" secondary={phone} />
      </ListItem>
      <Divider component="li" />
    </List>
  );
};

export default AccountInfo;
